import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-sample-card-alloggi',
  templateUrl: './sample-card-alloggi.component.html',
  styleUrls: ['./sample-card-alloggi.component.scss']
})
export class SampleCardAlloggiComponent implements OnInit {

  @Input() block: any;
  public stringTaxonomies: string = '';
  public isLinkEsternal: boolean = false;
  public objTitle = {
    title: '',
    hreflang: '',
    link: ''
  };

  constructor(
    private helperService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.setLabelTags();
    this.isLinkEsternal = this.objTitle.link ? this.helperService.verifyLinkExternal(this.objTitle.link) : false;
    this.objTitle = this.helperService.retriveLinkTagA(this.block.field_titolo, "a");
  }

  private setLabelTags() {
    let taxonomies: string[] = [];
    if (this.block.field_categorie_alloggi) {
      this.block.field_categorie_alloggi.forEach((taxonomy: any, idx: number) => {
        if (idx < 3) {
          taxonomies.push(taxonomy.name);
        }
      });
      if (this.block.field_categorie_alloggi.length > 3) {
        taxonomies.push(`+${this.block.field_categorie_alloggi.length - 3}`)
      }
    }
    this.stringTaxonomies = taxonomies.join(', ');
  }

}
